export * from 'vuelidate/lib/validators'

export const checked = (value: any) => Boolean(value);
